


















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { predefineColors } from '../../../constant/options';
import YcColorPicker from '@/components/color-picker/index.js';
import { PopSettingsVO, TFormSaveDetailRequest } from '@/model/FormWheel';
import { getVueAppUploadApi } from '@/services/util';
import { isEnableCloseButtonAdvanced } from '@/utils/experiment';
import CloseButtonSetting from './CloseButtonSetting.vue'

@Component({
  components: {
    'yc-color-picker': YcColorPicker,
    'close-button-setting': CloseButtonSetting
  }
})
export default class wheelOfFortuneTextCover extends Vue {
  @Prop(Object)
  formData!: TFormSaveDetailRequest<PopSettingsVO>;

  @Prop(Number)
  triggerEventType!: any;

  @Prop(Array)
  countryList!: any;

  @Prop(Array)
  pageSettings!: any;

  formDataStart: TFormSaveDetailRequest<PopSettingsVO> = this.formData;
  predefineColors = predefineColors;
  uploadUrl = getVueAppUploadApi() + '/upload/formImage';
  uploadDialogVisible = false;
  uploadDialogUrl = '';

  zpbgUploadFileList: { name: string; url: string }[] = [];
  zpbgUploadShow = false;

  get formStyle() {
    // 封面设置页面不需要复杂的表单样式
    return '';
  }

  get token() {
    return localStorage.getItem('token') || 'default';
  }

  created() {
    // 确保 cover 对象在组件创建时就存在
    if (!this.formDataStart.settings.cover) {
      this.formDataStart.settings.cover = {
        coverJumpType: 'click',
        bgCoverImgUrl: undefined
      };
    }
  }

  changeStart() {
    this.$forceUpdate();
    this.$emit('change', this.formDataStart);
    (window as any)?.gtagClick?.('form_edit_setCloseButton', '弹窗_编辑订阅工具_设置关闭按钮');
  }
  changeStartGA() {
    this.$forceUpdate();
    this.$emit('change', this.formDataStart);
    (window as any)?.gtagClick?.('form_edit_setCloseButton', '弹窗_编辑订阅工具_设置关闭按钮');
  }

  get enableCloseButtonAdvanced() {
    console.log('isEnableCloseButtonAdvanced()===', isEnableCloseButtonAdvanced())
    return isEnableCloseButtonAdvanced();
  }

  handleCloseButtonChange(config: any) {
    // 同步更新 cover.closeColor 以保持兼容
    if (config && config.iconColor) {
      this.formDataStart.settings.cover.closeColor = config.iconColor;
      // 同时同步到 rules.closeColor 以确保 pop.vue 预览兼容性
      if (this.formDataStart.settings.rules) {
        this.formDataStart.settings.rules.closeColor = config.iconColor;
      }
    }
    this.changeStart();
    (window as any)?.gtagClick?.('form_edit_setCloseButton', '弹窗_编辑订阅工具_设置关闭按钮');
  }

  @Watch('formData')
  changeFormData() {
    this.formDataStart = this.formData;
  }

  @Watch('formData.settings.cover.bgCoverImgUrl', { immediate: true })
  typesettingBGCoverImgUrlChange(val: string) {
    if (val) {
      this.zpbgUploadShow = true;
      this.zpbgUploadFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }

  /**
   * 图片上传失败钩子函数
   */
  zpbgHandleError(e: any): void {
    this.zpbgUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  zpbgHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.zpbgUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.cover && (this.formDataStart.settings.cover.bgCoverImgUrl = res.data[0].url);
      this.zpbgUploadFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.zpbgUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  zpbgBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.zpbgUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  zpbgUploadUrlDelete() {
    this.zpbgUploadShow = false;
    this.formDataStart?.settings?.cover && (this.formDataStart.settings.cover.bgCoverImgUrl = '');
    this.changeStart();
  }

  uploadUrlPreview(file: any) {
    this.uploadDialogUrl = file.url;
    this.uploadDialogVisible = true;
  }
}
